module.exports = __webpack_public_path__ + "img/yijia6.cf83ee26.jpg";